import Form from "./../../constant/Forms";
import axios from "axios";

export default {
  name: "ChangePasswordComponent",
  props: {
    index: String,
    user: String,
  },

  data() {
    return {
      employeeForm: Form.EMPLOYEE_FORM,
      polishStudentForm: Form.POLISH_STUDENT_FORM,
      foreignStudentForm: Form.FOREIGN_STUDENT_FORM,
      displayEmployeeForm: false,
      displayPolishStudentForm: false,
      displayForeignStudentForm: false,
      submitButtonName: "",
      showPassword: false,
      showRepeatPassword: false,
      errorPasswordMessages: "",
      errorRepeatPasswordMessages: "",
      form: "",
      snackbar: false,
      snackbarText: "",
      snackbarColor: "#439E69",
      dateMenu: false,
      API: "",
      employeeAPI: "https://csa.umw.edu.pl/app/reset-password.php",
      studentAPI: "https://csa.umw.edu.pl/app/reset-password-student.php",
      snackarCloseLabel: "Zamknij",
      redirectionTo: "",
      returnButtonName: "",
      isButtonActive: false,
    };
  },
  watch: {
    repeatPassword() {
      this.errorPasswordMessages = "";
      this.errorRepeatPasswordMessages = "";
    },
    dateMenu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  methods: {
    displayProperForm() {
      if (this.user == "employee") {
        this.displayEmployeeForm = true;
        this.form = this.employeeForm;
        this.API = this.employeeAPI;
        this.redirectionTo = "ChooseFormTypeComponent";
        this.returnButtonName = "Wróć";
      } else if (this.user == "polishStudent") {
        this.displayPolishStudentForm = true;
        this.form = this.polishStudentForm;
        this.API = this.studentAPI;
        this.redirectionTo = "ChooseUserTypeComponent";
        this.returnButtonName = "Wróć";
      } else if (this.user == "foreignStudent") {
        this.snackarCloseLabel = "Close";
        this.displayForeignStudentForm = true;
        this.form = this.foreignStudentForm;
        this.API = this.studentAPI;
        this.redirectionTo = "ChooseUserTypeComponent";
        this.returnButtonName = "Back";
      } else this.$router.push("/");

      this.getChangePasswordTitle();
      this.getChangePasswordText();
      this.setButtonName();
      this.updateRules();
    },

    returnRedirection() {},

    getChangePasswordTitle() {
      if (this.displayForeignStudentForm == true) return "Password change";
      else return "Zmiana hasła";
    },

    getChangePasswordText() {
      if (this.displayForeignStudentForm == true)
        return "The form below allow you to change password";
      else return "Poniższy formularz umożliwia zmianę hasła";
    },

    setButtonName() {
      if (this.user == "foreignStudent")
        this.submitButtonName = "Change password";
      else this.submitButtonName = "Zmień hasło";
    },

    checkPassword() {
      if (
        this.form.repeatPassword !== "" &&
        this.form.password !== this.form.repeatPassword
      ) {
        if (this.displayForeignStudentForm == true)
          this.errorPasswordMessages =
            '"New password" and "Repeat password" fields must be the same';
        else
          this.errorPasswordMessages =
            'Pola "Nowe hasło" oraz "Powtórz hasło" muszą być takie same';
      } else this.errorPasswordMessages = "";

      return true;
    },

    checkRepeatPassword() {
      if (
        this.form.password !== "" &&
        this.form.repeatPassword !== this.form.password
      ) {
        if (this.displayForeignStudentForm == true)
          this.errorRepeatPasswordMessages =
            '"New password" and "Repeat password" fields must be the same';
        else
          this.errorRepeatPasswordMessages =
            'Pola "Nowe hasło" oraz "Powtórz hasło" muszą być takie same';
      } else this.errorRepeatPasswordMessages = "";

      return true;
    },

    updateRules() {
      this.form.passwordRules.push(this.checkPassword);
      this.form.repeatPasswordRules.push(this.checkRepeatPassword);
    },

    resetForm() {
      // let readyFormData = '';
      // console.log(readyFormData);
      // console.log('form cleared');
    },

    saveFormData() {
      const version = "2.8"; //form version needed for backend validation

      if (this.employeeForm.valid) {
        return (this.readyEmployeeForm = {
          name: this.employeeForm.name,
          surname: this.employeeForm.surname,
          pesel: this.employeeForm.pesel,
          employeeNumber: this.employeeForm.employeeNumber,
          password: this.employeeForm.password,
          formType: "changePassword",
          version: version,
        });
      }

      if (this.polishStudentForm.valid) {
        return (this.readyPolishStudentForm = {
          name: this.polishStudentForm.name,
          surname: this.polishStudentForm.surname,
          index: this.polishStudentForm.index,
          pesel: this.polishStudentForm.pesel,
          email: this.polishStudentForm.privateMail,
          password: this.polishStudentForm.password,
          formType: "studentPL",
          version: version,
        });
      }

      if (this.foreignStudentForm.valid) {
        return (this.readyForeignStudentForm = {
          name: this.foreignStudentForm.name,
          surname: this.foreignStudentForm.surname,
          index: this.foreignStudentForm.index,
          passport: this.foreignStudentForm.idCard,
          email: this.foreignStudentForm.privateMail,
          birth: this.foreignStudentForm.birthDate,
          password: this.foreignStudentForm.password,
          formType: "studentEN",
          version: version,
        });
      }
    },

    clearFormData() {
      //clearing form after sending
      // console.log('elo');
      // this.$refs.changePasswordForm.reset();
      // this.form.password = "";
      // this.form.repeatPassword = "";
      // this.form.repeatPassword.$reset;
      // this.$refs.$reset;
      // this.$v.$reset;
    },

    saveDate(date) {
      this.$refs.dateMenu.save(date);
    },

    readyForm() {
      var readyFormData = new FormData();

      readyFormData.append("name", this.saveFormData().name);
      readyFormData.append("surname", this.saveFormData().surname);
      readyFormData.append("password", this.saveFormData().password);
      readyFormData.append("formType", this.saveFormData().formType);
      readyFormData.append("version", this.saveFormData().version);

      if (this.employeeForm.valid) {
        readyFormData.append("requestedFormType", "PR-ZH");
        readyFormData.append("pesel", this.saveFormData().pesel);
        readyFormData.append(
          "employeeNumber",
          this.saveFormData().employeeNumber,
        );
      } else if (this.polishStudentForm.valid) {
        readyFormData.append("requestedFormType", "ST-ZH");
        readyFormData.append("pesel", this.saveFormData().pesel);
        readyFormData.append("index", this.saveFormData().index);
        readyFormData.append("dowod", this.saveFormData().dowod);
        readyFormData.append("email", this.saveFormData().email);
      } else if (this.foreignStudentForm.valid) {
        readyFormData.append("requestedFormType", "ED-ZH");
        readyFormData.append("index", this.saveFormData().index);
        readyFormData.append("passport", this.saveFormData().passport);
        readyFormData.append("email", this.saveFormData().email);
        readyFormData.append("birth", this.saveFormData().birth);
      }

      return readyFormData;
    },

    validate() {
      this.isButtonActive = true; // disable button after sending form

      if (this.$refs.changePasswordForm.validate()) {
        var sendData = this.readyForm();

        axios
          .post(this.API, sendData)
          .then((res) => this.preparePopup(res.data))
          .catch((error) => console.log(error))
          .then(() => this.enableButton()); // enable button when sending form failes
      } else {
        this.preparePopup("invalidForm");
        this.isButtonActive = false; // enable button when sending form failes
      }
    },

    enableButton() {
      this.isButtonActive = false;
    },

    preparePopup(res) {
      console.log(res);

      this.snackbar = true;
      if (res.error == "01") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Please fill out all required information.";
        } else
          this.snackbarText = "Proszę uzupełnić wszystkie wymagane informacje.";
        this.snackbarColor = "#C14348";
      } else if (res.error == "02") {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "Provided index number is invalid. Please try again.";
        } else if (this.user == "polishStudent") {
          this.snackbarText = "Podany numer indeksu jest nieprawidłowy.";
        } else
          this.snackbarText =
            "Wystąpił błąd podczas zmiany hasła. Proszę spróbować ponownie.";

        this.snackbarColor = "#C14348";
      } else if (res.error == "03") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Provided data is invalid. Please try again.";
        } else
          this.snackbarText =
            "Wprowadzono błędne dane. Proszę spróbować ponownie.";

        this.snackbarColor = "#C14348";
      } else if (res.error == "04") {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "An error occurred while changing the password. Please try again later or contact admin@umw.edu.pl";
        } else
          this.snackbarText =
            "Wystąpił błąd podczas zmiany hasła. Proszę spróbować ponownie później lub kontaktować się na admin@umw.edu.pl";

        this.snackbarColor = "#C14348";
        // this.$refs.changePasswordForm.reset();
      } else if (res.error == "05") {
        this.snackbarText = "Konto, które próbujesz utworzyć, już istnieje.";
        this.snackbarColor = "#C14348";
        // this.$refs.changePasswordForm.reset();
      } else if (res.error == "06") {
        this.snackbarText =
          "Wystąpił problem ze znalezieniem podanej jednostki - hasło nie zostało zmienione. Prosimy o kontakt na admin@umw.edu.pl";
        this.snackbarColor = "#C14348";
        // this.$refs.changePasswordForm.reset();
      } else if (res.error == "07") {
        this.snackbarText =
          "Formularz rejestracji został wysłany poprawnie. Konto zostało utworzone.";
        this.snackbarColor = "#439E69";
        // this.$refs.changePasswordForm.reset();
      } else if (res.error == "08") {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "An error occurred while changing the password. Please try again later.";
        } else
          this.snackbarText =
            "Wystąpił błąd podczas zmiany hasła. Proszę spróbować ponownie.";

        this.snackbarColor = "#C14348";
        // this.$refs.changePasswordForm.reset();
      } else if (res.error == "09") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Account not found.";
        } else
          this.snackbarText =
            "Nie znaleziono konta. Hasło nie zostało zmienione.";
        this.snackbarColor = "#C14348";
        // this.$refs.changePasswordForm.reset();
      } else if (res.error == "10") {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "An error occurred while changing the password. Please try again later or contact admin@umw.edu.pl";
        } else
          this.snackbarText =
            "Wystąpił błąd podczas zmiany hasła. Proszę spróbować ponownie później lub kontaktować się na admin@umw.edu.pl";
        this.snackbarColor = "#C14348";
        // this.$refs.changePasswordForm.reset();
      } else if (res.error == "11") {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "An error occurred while changing the password. Please try again later or contact admin@umw.edu.pl";
        } else
          this.snackbarText =
            "Wystąpił błąd podczas zmiany hasła. Proszę spróbować ponownie później lub kontaktować się na admin@umw.edu.pl";
        this.snackbarColor = "#C14348";
        // this.$refs.changePasswordForm.reset();
      } else if (res.error == "12") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Password has been changed successfully.";
        } else this.snackbarText = "Hasło zostało poprawnie zmienione.";
        this.snackbarColor = "#439E69";
        // this.$refs.changePasswordForm.reset();
        this.clearFormData();
      } else if (res.error == "13") {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "An error occurred while changing the password. Please try again later or contact admin@umw.edu.pl";
        } else
          this.snackbarText =
            "Wystąpił błąd podczas zmiany hasła. Proszę spróbować ponownie później lub kontaktować się na admin@umw.edu.pl";
        this.snackbarColor = "#C14348";
        // this.$refs.changePasswordForm.reset();
      } else if (res.error == "14") {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "Found a change of personal data. Contact admin@umw.edu.pl";
        } else
          this.snackbarText =
            "Nie można zmienić hasła, gdyż wykryto zmianę danych osobowych. Skontaktuj się z administratorem admin@umw.edu.pl";
        this.snackbarColor = "#C14348";
        // this.$refs.changePasswordForm.reset();
      } else if (res.error == "15") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Wrong version. Refresh browser and try again.";
        } else
          this.snackbarText =
            "Niezgodna wersja. Odśwież przeglądarkę i spróbuj ponownie";
        this.snackbarColor = "#C14348";
        // this.$refs.changePasswordForm.reset();
      } else if (res.error == "99") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Wrong version. Refresh browser and try again.";
        } else
          this.snackbarText =
            "Niezgodna wersja. Odśwież przeglądarkę i spróbuj ponownie";
        this.snackbarColor = "#C14348";
        // this.$refs.changePasswordForm.reset();
      } else if (res.error == "23") {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "Incorrect Passport number or Identity Card, go to dean's Office, ask for correction on Virtual University system";
        } else
          this.snackbarText =
            "Błędny PESEL lub numer dowodu - skontaktuj się z dziekanatem";
        this.snackbarColor = "#C14348";
        // this.$refs.form.reset();
      } else if (res == "invalidForm") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Please fill out all required information.";
        } else
          this.snackbarText = "Proszę uzupełnić wszystkie wymagane informacje.";
        this.snackbarColor = "#C14348";
      } else if (!res.error) {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "An error occurred while changing the password. Please try again later or contact admin@umw.edu.pl";
        } else
          this.snackbarText =
            "Wystąpił błąd podczas zmiany hasła. Proszę spróbować ponownie później lub kontaktować się na admin@umw.edu.pl";
        this.snackbarColor = "#C14348";
        // this.$refs.changePasswordForm.reset();
      }
    },
  },
  created() {
    this.displayProperForm();
  },
};
